import React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { FaQuestion, FaQuestionCircle } from 'react-icons/fa';
import './TrickButton.css';

const TrickButton = ({
  text,
  placement = 'bottom',
  variant = 'outline-secondary',
  color = '#5d5d5d',
  size = 15,
}) => {
  const popover = (
    <Popover id="trick-popover"  className="custom-popover">
      <Popover.Body>{text}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement={placement}
      overlay={popover}
      trigger={['hover', 'focus']}
    >
      <Button
        variant={variant}
        className={`p-2 rounded-circle d-inline-flex align-items-center justify-content-center`}
        style={{ cursor: 'pointer' }}
      >
        <FaQuestion size={size} style={{ color: color }} />
      </Button>
    </OverlayTrigger>
  );
};

export default TrickButton;
